import type { Session } from '@supabase/supabase-js'
import { createClient } from '@supabase/supabase-js'
import { ref } from 'vue'
import type { Database } from '../types/database.types'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey)

export const session = ref<Session | null>(null)
supabase.auth.onAuthStateChange((_, _session) => {
  session.value = _session
})

/**Checks if a session is active and attempts to load one if it doesn't.
 * It's better to call this rather than checking the session ref directly.
 */
export async function checkSessionIsValid() {
  if (!session.value) {
    const result = await supabase.auth.getSession()
    if (result.error) {
      return false
    }
    session.value = result.data.session
  }
  if (!session.value) {
    return false
  }
  return true
}
